import React from 'react';


function Error() {
    return (
        <div>there was an error...</div>
    )
}

export default Error;